import { useState, useCallback } from "react";
import { getAxios } from "../utils/axios";
const endpoint = "/inventory/items";
export const useInventoryItems = () => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [total, setTotal] = useState(null);
    const fetchAll = useCallback(async (filter, options) => {
        setLoading(true);
        setError(null);
        console.log("Calling GET /inventory/items");
        try {
            const params = new URLSearchParams();
            if (filter) {
                params.set("filter", JSON.stringify(filter));
            }
            if (options?.search)
                params.set("search", options.search);
            if (options?.sort)
                params.set("sort", options.sort);
            if (options?.order)
                params.set("order", options.order);
            if (options?.include_deleted)
                params.set("include_deleted", "true");
            params.set("offset", String(options?.offset ?? 0));
            params.set("limit", String(options?.limit ?? 100));
            console.log("testing the connection", `${endpoint}?${params.toString()}`);
            const res = await getAxios().get(`${endpoint}?${params.toString()}`);
            console.log("🚀 Response from inventory:", res);
            if (!Array.isArray(res.data)) {
                console.warn("⚠️ Expected array but got:", res.data);
            }
            const totalHeader = res.headers?.["x-total-count"];
            if (typeof totalHeader !== "undefined") {
                const parsed = Number(totalHeader);
                setTotal(Number.isNaN(parsed) ? null : parsed);
            }
            if (options?.append) {
                setItems((prev) => {
                    const map = new Map(prev.map((item) => [item.uuid, item]));
                    (res.data || []).forEach((item) => {
                        if (item?.uuid) {
                            map.set(item.uuid, item);
                        }
                    });
                    return Array.from(map.values());
                });
            }
            else {
                setItems(res.data);
            }
        }
        catch (err) {
            setError(err.message || "Failed to fetch inventory items.");
        }
        finally {
            setLoading(false);
        }
    }, []);
    const create = async (payload) => {
        const res = await getAxios().post(endpoint, payload);
        await fetchAll();
        return res.data;
    };
    const update = async (uuid, payload) => {
        const res = await getAxios().put(`${endpoint}/${uuid}`, payload);
        await fetchAll();
        return res.data;
    };
    const patch = async (uuid, payload) => {
        const res = await getAxios().patch(`${endpoint}/${uuid}`, payload);
        await fetchAll();
        return res.data;
    };
    // const remove = async (uuid: string) => {
    //   const res = await getAxios().delete(`${endpoint}/${uuid}`);
    //   await fetchAll();
    //   return res.data;
    // };
    // ✅ DELETE logic goes through your streaming service, not raw /items/:uuid
    const remove = async (uuid, refetchFilter) => {
        await getAxios().delete(`${endpoint}/${uuid}`);
        await fetchAll(refetchFilter);
    };
    return { items, loading, error, total, fetchAll, create, update, patch, remove };
};
